module.exports = __webpack_public_path__ + "img/google.e4006a4f.png";